<template>
  <div class="user">
    <div class="header bg-color-red acea-row row-between-wrapper">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="pictrue">
          <img :src="userInfo.picture" v-if="userInfo.picture" />
          <img src="@assets/images/avatar.jpg" v-else />
        </div>
        <div class="text">
          <div class="acea-row row-middle">
            <div class="name line1">
              {{ userInfo.trueName || userInfo.nickname }}
            </div>
            <div class="member acea-row row-middle" v-if="userInfo.vip">
              <img :src="userInfo.vip_icon" />{{ userInfo.nickname }}
            </div>
          </div>
          <!--          <router-link :to="'/user/data'" class="id" v-if="userInfo.phone">-->
          <!--            ID：{{ userInfo.cardId || 0 }}<span class="iconfont icon-bianji1"></span>-->
          <!--          </router-link>-->
          <!--          <router-link :to="'/user/binding'" class="binding" v-else>-->
          <!--            <span>绑定手机号</span>-->
          <!--          </router-link>-->
          <div
            v-if="userInfo.shopName"
            @click="$router.push({ path: '/shop/switch' })"
          >
            {{ userInfo.shopName }} <icon name="exchange" />
          </div>
          <router-link
            :to="'/shop/binding'"
            class="binding"
            v-if="!userInfo.shopId"
          >
            <span>绑定会员</span>
          </router-link>
        </div>
      </div>
      <span
        class="iconfont icon-shezhi"
        @click="$router.push({ path: '/user/data' })"
      ></span>
    </div>
    <div class="wrapper">
      <div class="nav acea-row row-middle">
        <router-link :to="{ path: '/user/dossier' }" class="item">
          <div>我的余额</div>
          <div class="num">{{ userInfo.money || 0 }}</div>
        </router-link>
        <router-link :to="'/user/combo'" class="item">
          <div>剩余次数</div>
          <div class="num">{{ arrivalData.surplusNum || 0 }}次</div>
        </router-link>
        <router-link :to="'/user/consume'" class="item">
          <div>累计消费</div>
          <div class="num">{{ arrivalData.consumeNum || 0 }}次</div>
        </router-link>
      </div>
      <div class="myOrder">
        <div class="title acea-row row-between-wrapper">
          <div>我的订单</div>
          <router-link :to="'/order/list/'" class="allOrder">
            全部订单<span class="iconfont icon-jiantou"></span>
          </router-link>
        </div>
        <div class="orderState acea-row row-middle">
          <router-link :to="{ path: '/order/list/' + 0 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfk.png" />
              <span class="order-status-num" v-if="orderStatusNum.unpaid > 0">{{
                orderStatusNum.unpaid
              }}</span>
            </div>
            <div>待付款</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 1 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.unshipped > 0"
                >{{ orderStatusNum.unshipped }}</span
              >
            </div>
            <div>待签字</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 2 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dsh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.received > 0"
                >{{ orderStatusNum.received }}</span
              >
            </div>
            <div>已完成</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 3 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dpj.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.evaluated > 0"
                >{{ orderStatusNum.evaluated }}</span
              >
            </div>
            <div>待评价</div>
          </router-link>
          <router-link :to="'/order/refund_list'" class="item">
            <div class="pictrue">
              <img src="@assets/images/sh.png" />
              <span class="order-status-num" v-if="orderStatusNum.refund > 0">{{
                orderStatusNum.refund
              }}</span>
            </div>
            <div>售后/退款</div>
          </router-link>
          <!--          <router-link :to="'/icon'" class="item">-->
          <!--            <div class="pictrue">-->
          <!--              <img src="@assets/images/sh.png" />-->
          <!--              <span class="order-status-num" v-if="orderStatusNum.refund > 0">{{ orderStatusNum.refund }}</span>-->
          <!--            </div>-->
          <!--            <div>icon</div>-->
          <!--          </router-link>-->
        </div>
      </div>
      <div class="myService">
        <div class="title acea-row row-middle">我的服务</div>
        <div class="serviceList acea-row row-middle">
          <div class="item" @click="$router.push({ path: '/user/dossier' })">
            <div class="pictrue">
              <i class="iconfont icon-jingpintuijian"></i>
            </div>
            <div>我的档案</div>
          </div>
          <div class="item" @click="$router.push({ path: '/user/combo' })">
            <div class="pictrue">
              <i class="iconfont icon-pailie"></i>
            </div>
            <div>我的卡项</div>
          </div>
          <div class="item" @click="$router.push({ path: '/user/discount' })">
            <div class="pictrue">
              <i class="iconfont icon-liwu_o"></i>
            </div>
            <div>我的优惠</div>
          </div>
          <div class="item" @click="$router.push({ path: '/user/coupon' })">
            <div class="pictrue">
              <i class="iconfont icon-youhuiquan"></i>
            </div>
            <div>优 惠 券</div>
          </div>
          <div class="item" @click="$router.push({ path: '/user/recharge' })">
            <div class="pictrue">
              <i class="iconfont icon-chongzhi"></i>
            </div>
            <div>充值记录</div>
          </div>
          <div class="item" @click="$router.push({ path: '/user/consume' })">
            <div class="pictrue">
              <i class="iconfont icon-jingyanzhi"></i>
            </div>
            <div>服务记录</div>
          </div>
          <div class="item" @click="$router.push({ path: '/user/plan' })">
            <div class="pictrue">
              <i class="iconfont icon-shenhezhong"></i>
            </div>
            <div>预约记录</div>
          </div>
          <div class="item" @click="$router.push({ path: '/user/integral' })">
            <div class="pictrue">
              <i class="iconfont icon-remen"></i>
            </div>
            <div>我的积分</div>
          </div>
          <!--          <div class="item" @click="$router.push({ path: '/user/adviser' })">-->
          <!--            <div class="pictrue">-->
          <!--              <i class="iconfont icon-pintuan-copy"></i>-->
          <!--            </div>-->
          <!--            <div>我的顾问</div>-->
          <!--          </div>-->
        </div>
      </div>
    </div>
    <div class="footer-line-height"></div>
    <SwitchWindow
      v-on:changeswitch="changeswitch"
      :switchActive="switchActive"
      :login_type="userInfo.login_type"
    ></SwitchWindow>
  </div>
</template>
<script>
import { getUser, getArrivalData, switchUser } from "@api/user";
import { Icon } from "vant";
import { isWeixin } from "@utils";
import SwitchWindow from "@components/SwitchWindow";
import { mapGetters } from "vuex";
import { clearAuthStatus } from "@libs/wechat";

const NAME = "User";

export default {
  name: NAME,
  components: {
    SwitchWindow,
    Icon,
  },
  props: {},
  data: function () {
    return {
      userInfo: {},
      orderStatusNum: {},
      arrivalData: {},
      switchActive: false,
      isWeixin: false,
    };
  },
  computed: mapGetters(["userInfo"]),
  mounted: function () {
    this.init(this.$route.params.id);
  },
  methods: {
    changeswitch: function (data) {
      this.switchActive = data;
    },
    init(id) {
      this.isWeixin = isWeixin();
      if (id) {
        this.switchUser(id);
      } else {
        this.getUser();
        this.getArrival();
      }
    },
    getUser: function () {
      getUser().then((res) => {
        this.userInfo = res.result;
      });
    },
    switchUser: function (id) {
      switchUser(id).then((res) => {
        if (res.code == 200) {
          clearAuthStatus();
          this.$store.commit("LOGIN", res.result);
          this.$store.dispatch("USERINFO", true).then(() => {
            this.getUser();
            this.getArrival();
          });
        }
      });
    },

    getArrival: function () {
      getArrivalData().then((res) => {
        this.arrivalData = res.result;
      });
    },
  },
};
</script>

<style scoped>
.footer-line-height {
  height: 1rem;
}
.order-status-num {
  min-width: 0.33rem;
  background-color: #fff;
  color: #ee5a52;
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 0.2rem;
  padding: 0 0.08rem;
  border: 1px solid #ee5a52;
}

.pictrue {
  position: relative;
  color: #f06357;
}
.switch-h5 {
  margin-left: 0.2rem;
}
.binding {
  padding: 0.05rem 0.2rem;
  background-color: #ca1f10;
  border-radius: 50px;
  font-size: 0.14rem;
  border: 1px solid #e8695e;
  color: #ffffff;
}
</style>
